import React from "react";
import { PhotoIcon } from "@heroicons/react/24/outline";
import { classNames } from "src/helpers/classNames";

const PlaceholderImage = ({ text = "No Image", containerClasses }) => {
  return (
    <div className={classNames("flex h-full w-full flex-col items-center justify-center rounded-md border-2 border-gray-300 bg-gray-100", containerClasses)}>
      <PhotoIcon className="h-1/2 w-1/2 text-gray-400" />
      <p className="mt-2 select-none  text-gray-500">{text}</p>
    </div>
  );
};

export default PlaceholderImage;
